import React from "react";

const Loader = ({ width = "w-6", height = "h-6", fullScreen = false }) => {
    return (
        <div
            className={`flex justify-center items-center ${
                fullScreen ? "h-screen" : "h-64"
            } w-full`}
        >
            <div
                className={`animate-spin rounded-full ${height} ${width} border-t-2 border-b-2 border-[#672c71]`}
            ></div>
        </div>
    )
}

export default Loader;